[
	{
		"Analysis_No": "125041",
		"Component": "TEST HOUSING",
		"Component_No": null,
		"Testing_Specification": null,
		"Customer": "Testgruppe Group GmbH & Co. KG",
		"customer_no": "10000",
		"Examiner": "Mustermann",
		"Date_of_arrival": null,
		"Date_of_Extraction": "2022-11-15T15:45:03",
		"Date_of_Analysis": "2022-11-16T00:00:00",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"Fliter_Type": null,
		"filter_diameter": "47 mm",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Comment": null,
		"Record_of_Editing": null,
		"Scale": "5,4 µm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.06992799788713455,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 126,
		"woF_15_25": 55,
		"woF_25_50": 51,
		"woF_50_100": 73,
		"woF_100_150": 47,
		"woF_150_200": 14,
		"woF_200_400": 10,
		"woF_400_600": 0,
		"woF_600_1000": 0,
		"woF_gt_1000": 0,
		"woF_200_300": 9,
		"woF_300_400": 1,
		"woF_400_500": 0,
		"woF_500_600": 0,
		"woF_600_700": 0,
		"woF_700_800": 0,
		"woF_800_900": 0,
		"woF_900_1000": 0,
		"woF_1000_1500": 0,
		"woF_1500_2000": 0,
		"woF_2000_2500": 0,
		"woF_2500_3000": 0,
		"woF_gt_3000": 0,
		"All_5_15": 126,
		"All_15_25": 55,
		"All_25_50": 51,
		"All_50_100": 73,
		"All_100_150": 47,
		"All_150_200": 14,
		"All_200_400": 15,
		"All_400_600": 1,
		"All_600_1000": 1,
		"All_gt_1000": 1,
		"All_200_300": 10,
		"All_300_400": 5,
		"All_400_500": 0,
		"All_500_600": 1,
		"All_600_700": 1,
		"All_700_800": 0,
		"All_800_900": 0,
		"All_900_1000": 0,
		"All_1000_1500": 1,
		"All_1500_2000": 0,
		"All_2000_2500": 0,
		"All_2500_3000": 0,
		"All_gt_3000": 0,
		"Met_5_15": 1,
		"Met_15_25": 1,
		"Met_25_50": 1,
		"Met_50_100": 21,
		"Met_100_150": 44,
		"Met_150_200": 11,
		"Met_200_400": 9,
		"Met_400_600": 0,
		"Met_600_1000": 0,
		"Met_gt_1000": 0,
		"Met_200_300": 9,
		"Met_300_400": 0,
		"Met_400_500": 0,
		"Met_500_600": 0,
		"Met_600_700": 0,
		"Met_700_800": 0,
		"Met_800_900": 0,
		"Met_900_1000": 0,
		"Met_1000_1500": 0,
		"Met_1500_2000": 0,
		"Met_2000_2500": 0,
		"Met_2500_3000": 0,
		"Met_gt_3000": 0,
		"woFNM_1L": 323.0,
		"woFNM_1W": 94.0,
		"woFNM_2L": 198.0,
		"woFNM_2W": 86.0,
		"woFNM_3L": 170.0,
		"woFNM_3W": 38.0,
		"woFNM_4L": 155.0,
		"woFNM_4W": 49.0,
		"woFNM_5L": 141.0,
		"woFNM_5W": 22.0,
		"Met_1L": 278.0,
		"Met_1W": 194.0,
		"Met_2L": 246.0,
		"Met_2W": 124.0,
		"Met_3L": 244.0,
		"Met_3W": 113.0,
		"Met_4L": 232.0,
		"Met_4W": 163.0,
		"Met_5L": 226.0,
		"Met_5W": 119.0,
		"Fib_Fmax1_Fmax": 1422.0,
		"Fib_Fmax1_Lstr": 2200.0,
		"Fib_Fmax2_Fmax": 625.0,
		"Fib_Fmax2_Lstr": 1075.0,
		"Fib_Fmax_Sum_um": 4389.0,
		"Fib_Stretched_Sum_um": 6590.0,
		"woF_weighted_sum": 547.0,
		"All_weighted_sum": 1235.0,
		"Met_weighted_sum": 440.0,
		"betaufnr": 125041.0,
		"artsuch": "TEST HOUSING",
		"artnr": 5024982,
		"bemmem": null,
		"artbez1": null,
		"artbez2": null,
		"artbez3": null,
		"artbezmem": null,
		"zeichnr": "TEST Housing RH BR465",
		"zeichindex": "ABC",
		"katseite": "",
		"prodtext": null,
		"ioResult": true,
		"jomesa_count": null,
		"is_fallback": false,
		"met_sum": 9.0,
		"nm_sum": 1.0,
		"fibers_sum": 8.0,
		"filtersize": "40.0",
		"smallest_size_class": "200",
		"analysis_id": 125041
	},
	{
		"Analysis_No": "125040",
		"Component": "TEST HOUSING",
		"Component_No": null,
		"Testing_Specification": null,
		"Customer": "Testgruppe Group GmbH & Co. KG",
		"customer_no": "10000",
		"Examiner": "Mustermann",
		"Date_of_arrival": null,
		"Date_of_Extraction": "2022-11-15T15:45:03",
		"Date_of_Analysis": "2022-11-16T00:00:00",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"Fliter_Type": null,
		"filter_diameter": "47 mm",
		"Parts_on_Filter": 1.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": null,
		"Comment": null,
		"Record_of_Editing": null,
		"Scale": "5,4 µm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.10187400132417679,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 159,
		"woF_15_25": 49,
		"woF_25_50": 35,
		"woF_50_100": 77,
		"woF_100_150": 59,
		"woF_150_200": 27,
		"woF_200_400": 10,
		"woF_400_600": 0,
		"woF_600_1000": 1,
		"woF_gt_1000": 0,
		"woF_200_300": 7,
		"woF_300_400": 3,
		"woF_400_500": 0,
		"woF_500_600": 0,
		"woF_600_700": 1,
		"woF_700_800": 0,
		"woF_800_900": 0,
		"woF_900_1000": 0,
		"woF_1000_1500": 0,
		"woF_1500_2000": 0,
		"woF_2000_2500": 0,
		"woF_2500_3000": 0,
		"woF_gt_3000": 0,
		"All_5_15": 159,
		"All_15_25": 49,
		"All_25_50": 35,
		"All_50_100": 77,
		"All_100_150": 59,
		"All_150_200": 27,
		"All_200_400": 15,
		"All_400_600": 0,
		"All_600_1000": 4,
		"All_gt_1000": 2,
		"All_200_300": 10,
		"All_300_400": 5,
		"All_400_500": 0,
		"All_500_600": 0,
		"All_600_700": 1,
		"All_700_800": 2,
		"All_800_900": 0,
		"All_900_1000": 1,
		"All_1000_1500": 0,
		"All_1500_2000": 1,
		"All_2000_2500": 0,
		"All_2500_3000": 0,
		"All_gt_3000": 1,
		"Met_5_15": 0,
		"Met_15_25": 0,
		"Met_25_50": 0,
		"Met_50_100": 25,
		"Met_100_150": 46,
		"Met_150_200": 24,
		"Met_200_400": 7,
		"Met_400_600": 0,
		"Met_600_1000": 1,
		"Met_gt_1000": 0,
		"Met_200_300": 6,
		"Met_300_400": 1,
		"Met_400_500": 0,
		"Met_500_600": 0,
		"Met_600_700": 1,
		"Met_700_800": 0,
		"Met_800_900": 0,
		"Met_900_1000": 0,
		"Met_1000_1500": 0,
		"Met_1500_2000": 0,
		"Met_2000_2500": 0,
		"Met_2500_3000": 0,
		"Met_gt_3000": 0,
		"woFNM_1L": 320.0,
		"woFNM_1W": 210.0,
		"woFNM_2L": 305.0,
		"woFNM_2W": 149.0,
		"woFNM_3L": 229.0,
		"woFNM_3W": 86.0,
		"woFNM_4L": 194.0,
		"woFNM_4W": 51.0,
		"woFNM_5L": 177.0,
		"woFNM_5W": 70.0,
		"Met_1L": 616.0,
		"Met_1W": 130.0,
		"Met_2L": 370.0,
		"Met_2W": 328.0,
		"Met_3L": 239.0,
		"Met_3W": 129.0,
		"Met_4L": 234.0,
		"Met_4W": 65.0,
		"Met_5L": 233.0,
		"Met_5W": 156.0,
		"Fib_Fmax1_Fmax": 3834.0,
		"Fib_Fmax1_Lstr": 5413.0,
		"Fib_Fmax2_Fmax": 1759.0,
		"Fib_Fmax2_Lstr": 2152.0,
		"Fib_Fmax_Sum_um": 9408.0,
		"Fib_Stretched_Sum_um": 13464.0,
		"woF_weighted_sum": 860.0,
		"All_weighted_sum": 2172.0,
		"Met_weighted_sum": 681.0,
		"betaufnr": 125040.0,
		"artsuch": "TEST HOUSING",
		"artnr": 5024982,
		"bemmem": null,
		"artbez1": null,
		"artbez2": null,
		"artbez3": null,
		"artbezmem": null,
		"zeichnr": "TEST Housing RH BR465",
		"zeichindex": "ABC",
		"katseite": "",
		"prodtext": null,
		"ioResult": false,
		"jomesa_count": null,
		"is_fallback": false,
		"met_sum": 8.0,
		"nm_sum": 3.0,
		"fibers_sum": 10.0,
		"filtersize": "40.0",
		"smallest_size_class": "200",
		"analysis_id": 125040
	}
]
